import { ChangeDetectorRef, Component, EventEmitter, Inject, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { DatagridComponent } from '@farris/ui-datagrid';
import { MessagerService } from '@farris/ui-messager';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrls: ['./activity-list.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class ActivityListComponent implements OnInit {

  @Output() closeEmitter = new EventEmitter<any>();
  @Output() submitEmitter = new EventEmitter<any>();
  @ViewChild('buttonRef') buttonRef: TemplateRef<any>;
  @ViewChild('grid') grid: DatagridComponent;

  multiSelect = true;
  showCheckbox = true;
  data = new Array();
  columns = [
    { title: this.localePipe.transform('component.activityList.name'), field: 'Name', width: 60 },
    { title: 'ID', field: 'Id', width: 90 }
  ];

  constructor(
    private designerUIState: ProcessDesignerUIState,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {
    this.data = this.designerUIState.userActList;
  }

  clickOK() {
    const result = this.grid.checkeds;
    if (!result || result.length === 0) {
      this.message.info(this.localePipe.transform('component.activityList.checkeds'));
      return;
    }
    this.submitEmitter.emit(result);
  }

  clickCancel() {
    this.closeEmitter.emit();
  }

}
